type WebviewBridgeEvent = 'launchUrl'

export default () => {
  const _isWebview = useState<boolean>('isWebview', () => false)
  const { $isWebview } = useNuxtApp()

  function setIsWebview(value: boolean) {
    _isWebview.value = value
  }

  const isWebview = computed(() => {
    return $isWebview || _isWebview.value
  })

  function launchUrl(url: string) {
    window.WebviewBridge.postMessage(
      JSON.stringify({
        event: 'launchUrl',
        url,
      }),
    )
  }

  function shareWithKakaoTalk(param: { title: string, description: string, imageUrl: string, linkUrl: string }) {
    window.WebviewBridge.postMessage(
      JSON.stringify({
        event: 'shareWithKakaoTalk',
        ...param,
      }),
    )
  }

  function loginWithApple() {
    window.WebviewBridge.postMessage(
      JSON.stringify({
        event: 'loginWithApple',
      }),
    )
  }

  function loginWithKakao() {
    window.WebviewBridge.postMessage(
      JSON.stringify({
        event: 'loginWithKakao',
      }),
    )
  }

  function loginWithGoogle() {
    window.WebviewBridge.postMessage(
      JSON.stringify({
        event: 'loginWithGoogle',
      }),
    )
  }

  return {
    launchUrl,
    shareWithKakaoTalk,
    loginWithApple,
    loginWithKakao,
    loginWithGoogle,
    setIsWebview,
    isWebview,
  }
}
